// extracted by mini-css-extract-plugin
module.exports = {"link-container":"link-container___1pjGq","linkContainer":"link-container___1pjGq","link":"link___3MGYQ"};